/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeButton,
  BaSeDatePicker,
  BaSeGrid,
  BaSeGridItem,
  BaSeParagraph,
} from '@base/react';
import React from 'react';

function ProcessingDate({
  title,
  handleChange,
  filters,
  fixedFilters,
  handleFixedFilter,
  insideFilter,
  setFilter,
  convertDate,
}) {
  const handleChangeoUTSIDEfilter = React.useCallback(
    (key, value) => {
      setFilter((prevFilter) => {
        return {
          ...prevFilter,
          [key]: convertDate(value),
        };
      });
    },
    [setFilter, convertDate],
  );

  return (
    <BaSeGrid gap={6}>
      <BaSeGridItem size={insideFilter ? 12 : 8}>
        <BaSeParagraph color="#939393">{title}</BaSeParagraph>
      </BaSeGridItem>

      <BaSeGridItem size={insideFilter ? 5 : 6}>
        <BaSeDatePicker
          size="small"
          startDate={filters.initialProcessingDate}
          onStartDateChange={(date) => {
            handleChange('initialProcessingDate', date);
            if (!insideFilter) {
              handleChangeoUTSIDEfilter('initialProcessingDate', date);
            }
          }}
          onSelect={(date) => {
            handleChange('initialProcessingDate', date);
            if (!insideFilter) {
              handleChangeoUTSIDEfilter('initialProcessingDate', date);
            }
          }}
          placeholder="Data de início"
        />
      </BaSeGridItem>
      <BaSeGridItem size={insideFilter ? 5 : 6}>
        <BaSeDatePicker
          size="small"
          startDate={filters.finalProcessingDate}
          placeholder="Data de término"
          onStartDateChange={(date) => {
            handleChange('finalProcessingDate', date);
            if (!insideFilter) {
              handleChangeoUTSIDEfilter('finalProcessingDate', date);
            }
          }}
          onSelect={(date) => {
            handleChange('finalProcessingDate', date);
            if (!insideFilter) {
              handleChangeoUTSIDEfilter('finalProcessingDate', date);
            }
          }}
        />
      </BaSeGridItem>

      {insideFilter && (
        <BaSeGridItem size={2}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <BaSeButton
              value={fixedFilters.processingDate ? 'Desafixar' : 'Fixar'}
              type="tertiary"
              color={fixedFilters.processingDate ? '#ffa4a4' : '#005EB8'}
              onClick={() => {
                handleFixedFilter('processingDate');
              }}
            />
          </div>
        </BaSeGridItem>
      )}
    </BaSeGrid>
  );
}

export default ProcessingDate;
